import { graphql } from 'gatsby'
import { normalizedData } from '@utils'
import Layout from '@layout'
import Header from '@layout/header/layout-01'
import Footer from '@layout/footer/layout-01'
import PageHeader from '@containers/page-header/layout-04'
import TextArea from '@containers/text/layout-01'
import KompassStrukturierteWertpapiereArea from '@containers/kompass-strukturierte-wertpapiere/layout-01'

const KompassStrukturierteWertpapierePage = ({ location, data }) => {
  const content = normalizedData(data?.strapiPage?.content || [])

  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <PageHeader
          data={{
            ...content['header-section']
          }}
        />
        <TextArea
          data={{
            ...content['einleitung-section']
          }}
        />
        <KompassStrukturierteWertpapiereArea
          data={{
            ...content['document-section']
          }}
          bg="white"
        />
      </main>
      <Footer />
    </Layout>
  )
}

export { Head } from '@components/head'

export const query = graphql`
  query KompassStrukturierteWertpapierePageQuery(
    $title: String
    $locale: String
  ) {
    strapiPage(
      title: { eq: $title }
      pageType: { eq: "innerpage" }
      locale: { eq: $locale }
    ) {
      content {
        ...StrapiPageContent
      }
      seo {
        ...StrapiPageSEO
      }
    }
  }
`

export default KompassStrukturierteWertpapierePage
